import React from 'react';
import ReactCustomScrollbars from 'react-custom-scrollbars';
import classNames from 'classnames';
import pt from 'prop-types';

import './scrollbars.scss';

export default class Scrollbars extends React.PureComponent {
  static propTypes = {
    children: pt.node,
    className: pt.string,
    autoHeight: pt.bool,
  };

  renderTrackVertical(props) {
    return (
      <div {...props} className="scrollbars-track scrollbars-track-vertical" />
    );
  }

  renderThumbVertical(props) {
    return (
      <div {...props} className="scrollbars-thumb scrollbars-thumb-vertical" />
    );
  }

  renderTrackHorizontal(props) {
    return (
      <div
        {...props}
        className="scrollbars-track scrollbars-track-horizontal"
      />
    );
  }

  renderThumbHorizontal(props) {
    return (
      <div
        {...props}
        className="scrollbars-thumb scrollbars-thumb-horizontal"
      />
    );
  }

  render() {
    const { className, autoHeight, children, ...props } = this.props;

    return (
      <ReactCustomScrollbars
        autoHide
        autoHeight={Boolean(autoHeight)}
        autoHeightMin={0}
        autoHeightMax={1000000}
        className={classNames('Scrollbars', className)}
        hideTracksWhenNotNeeded
        renderTrackVertical={this.renderTrackVertical}
        renderThumbVertical={this.renderThumbVertical}
        renderTrackHorizontal={this.renderTrackHorizontal}
        renderThumbHorizontal={this.renderThumbHorizontal}
        {...props}
      >
        {children}
      </ReactCustomScrollbars>
    );
  }
}
